import packageJson from "../../package.json";

export type DeviceDetails = {
  appVersion?: string;
  browserVersion?: string;
  userAgent?: string;
  platform?: string;
  windowHeight?: number;
  windowWidth?: number;
};

export class Email {
  constructor(
    public to?: string, // back-end will restrict based on amplify env configuration
    public message?: string,
    public subject?: string,
    public screen?: string,
    public deviceDetails?: DeviceDetails
  ) {}

  static getDeviceDetails(): DeviceDetails {
    return {
      appVersion: packageJson.version,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  }

  toJSON(): any {
    return {
      to: this.to,
      message: this.message,
      subject: this.subject,
      screen: this.screen,
      deviceDetails: this.deviceDetails
        ? {
            appVersion: this.deviceDetails?.appVersion,
            userAgent: this.deviceDetails?.userAgent,
            platform: this.deviceDetails?.platform,
            windowHeight: this.deviceDetails?.windowHeight,
            windowWidth: this.deviceDetails?.windowWidth,
          }
        : undefined,
    };
  }
}
